import { Injectable } from '@angular/core';
import { Observable, of, shareReplay, switchMap, map, catchError } from 'rxjs';
import { NativeServiceApiProvider } from '../../services/native-api-provider.service';

@Injectable({
  providedIn: 'root',
})
export class PersonContactCacheService {
  private photoByPersonId = new Map<number, string | null>();
  private photoRequestByPersonId = new Map<number, Observable<string | null>>();

  constructor(private provider: NativeServiceApiProvider) {}

  getPhotoUrl(personId: number): Observable<string | null> {
    if (!personId) {
      return of(null);
    }
    if (this.photoByPersonId.has(personId)) {
      return of(this.photoByPersonId.get(personId) ?? null);
    }
    const inFlight = this.photoRequestByPersonId.get(personId);
    if (inFlight) {
      return inFlight;
    }
    const request$ = this.provider.casa().pipe(
      switchMap((api) => api.getPhoto(personId)),
      map((photo) => photo?.publicAccessUrl ?? null),
      catchError(() => of(null)),
      map((photoUrl) => {
        this.photoByPersonId.set(personId, photoUrl);
        return photoUrl;
      }),
      shareReplay(1)
    );
    this.photoRequestByPersonId.set(personId, request$);
    return request$;
  }

  getPhotoUrlSync(personId: number): string | null {
    if (!personId) {
      return null;
    }
    return this.photoByPersonId.get(personId) ?? null;
  }
}
